import { render, staticRenderFns } from "./unfinished-test.vue?vue&type=template&id=e4d8cd1c&scoped=true"
import script from "./unfinished-test.vue?vue&type=script&lang=js"
export * from "./unfinished-test.vue?vue&type=script&lang=js"
import style0 from "./unfinished-test.vue?vue&type=style&index=0&id=e4d8cd1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d8cd1c",
  null
  
)

export default component.exports